import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'concourse-static-table',
  templateUrl: './static-table.component.html',
  styleUrls: ['./static-table.component.scss']
})
export class StaticTableComponent implements OnInit, OnChanges {

  public isExpanded:boolean = false;
  @Input('cutsheet') cutsheet:any = {};
  constructor() { }

  ngOnChanges() {
    console.log(this.cutsheet);
  }

  ngOnInit(): void {
  }

}
